module.exports = __webpack_public_path__ + "static/media/screenshot-twitter.83a0c05d.jpg";